import React from 'react';

// Mini visual certificate preview rendered as CSS/SVG.
// variant: 'classic' | 'modern' | 'govt' | 'private-hospital' | 'clinic'

const TemplatePreview = ({ variant }) => {
  if (variant === 'classic') {
    return (
      <svg viewBox="0 0 120 160" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect width="120" height="160" fill="#ffffff" stroke="#111" strokeWidth="1" />
        {/* Header */}
        <text x="60" y="14" textAnchor="middle" fontSize="7" fontFamily="serif" fontWeight="700" fill="#111">DR. R. SHARMA</text>
        <text x="60" y="22" textAnchor="middle" fontSize="4" fontFamily="serif" fill="#444">MBBS, MD (Med.)</text>
        <line x1="10" y1="28" x2="110" y2="28" stroke="#111" strokeWidth="0.5" />
        {/* Rx */}
        <text x="14" y="42" fontSize="14" fontFamily="serif" fontStyle="italic" fontWeight="700" fill="#111">℞</text>
        {/* Lines */}
        {[50, 58, 66, 74, 82, 90, 98, 106, 114].map((y) => (
          <line key={y} x1="14" y1={y} x2="106" y2={y} stroke="#bbb" strokeWidth="0.3" strokeDasharray="1,1" />
        ))}
        {/* signature */}
        <path d="M70 130 Q 80 122, 90 130 T 105 130" stroke="#111" strokeWidth="0.6" fill="none" />
        <text x="86" y="142" textAnchor="middle" fontSize="3.5" fill="#444">Signature</text>
        <rect x="14" y="125" width="22" height="22" rx="2" stroke="#111" strokeWidth="0.5" fill="none" />
        <text x="25" y="138" textAnchor="middle" fontSize="3" fill="#444">Stamp</text>
      </svg>
    );
  }

  if (variant === 'modern') {
    return (
      <svg viewBox="0 0 120 160" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect width="120" height="160" fill="#ffffff" />
        {/* Teal masthead */}
        <rect width="120" height="28" fill="#0d9488" />
        <circle cx="14" cy="14" r="6" fill="#ffffff" />
        <path d="M11 14 h6 M14 11 v6" stroke="#0d9488" strokeWidth="1.4" />
        <text x="24" y="13" fontSize="6" fontFamily="sans-serif" fontWeight="700" fill="#ffffff">CITY CARE</text>
        <text x="24" y="20" fontSize="3.5" fontFamily="sans-serif" fill="#bef4ec">multispeciality hospital</text>
        {/* Patient row */}
        <rect x="10" y="34" width="100" height="10" fill="#f0fdfa" rx="1" />
        <text x="14" y="41" fontSize="3.5" fill="#0f766e">Patient: ____________ Age: __</text>
        {/* Body lines */}
        {[52, 60, 68, 76, 84, 92, 100, 108].map((y) => (
          <line key={y} x1="14" y1={y} x2="106" y2={y} stroke="#cbd5e1" strokeWidth="0.4" />
        ))}
        {/* Signature & seal */}
        <circle cx="95" cy="135" r="9" fill="none" stroke="#0d9488" strokeWidth="0.6" strokeDasharray="1,1" />
        <text x="95" y="137" textAnchor="middle" fontSize="3" fill="#0d9488" fontWeight="700">SEAL</text>
        <path d="M14 140 Q 24 132, 34 140 T 54 140" stroke="#0d9488" strokeWidth="0.7" fill="none" />
        <text x="34" y="150" textAnchor="middle" fontSize="3" fill="#0f766e">{"Dr's Sign"}</text>
      </svg>
    );
  }

  if (variant === 'govt') {
    return (
      <svg viewBox="0 0 120 160" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect width="120" height="160" fill="#ffffff" />
        {/* Saffron / white / green band */}
        <rect width="120" height="6" fill="#ff9933" />
        <rect width="120" y="6" height="6" fill="#ffffff" />
        <rect width="120" y="12" height="6" fill="#138808" />
        {/* Ashoka */}
        <circle cx="60" cy="9" r="2.5" fill="none" stroke="#000080" strokeWidth="0.5" />
        {/* Header */}
        <text x="60" y="26" textAnchor="middle" fontSize="5.5" fontFamily="serif" fontWeight="700" fill="#1f2937">GOVT. CIVIL HOSPITAL</text>
        <text x="60" y="32" textAnchor="middle" fontSize="3" fill="#6b7280">Ministry of Health, GoI</text>
        <line x1="10" y1="36" x2="110" y2="36" stroke="#4b5563" strokeWidth="0.4" />
        {/* CMO No */}
        <text x="14" y="44" fontSize="3.5" fill="#374151">CMO No.: GH/2026/____</text>
        <text x="80" y="44" fontSize="3.5" fill="#374151">Date: __/__/____</text>
        {/* Body lines */}
        {[54, 62, 70, 78, 86, 94, 102, 110].map((y) => (
          <line key={y} x1="14" y1={y} x2="106" y2={y} stroke="#9ca3af" strokeWidth="0.3" />
        ))}
        {/* Official stamp */}
        <circle cx="30" cy="135" r="11" fill="none" stroke="#16a34a" strokeWidth="0.8" />
        <circle cx="30" cy="135" r="7" fill="none" stroke="#16a34a" strokeWidth="0.4" strokeDasharray="1,1" />
        <text x="30" y="137" textAnchor="middle" fontSize="3" fill="#16a34a" fontWeight="700">GOVT</text>
        <path d="M70 138 Q 80 130, 90 138 T 105 138" stroke="#1f2937" strokeWidth="0.6" fill="none" />
      </svg>
    );
  }

  if (variant === 'private-hospital') {
    return (
      <svg viewBox="0 0 120 160" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect width="120" height="160" fill="#ffffff" />
        {/* Navy gradient header */}
        <defs>
          <linearGradient id="phHead" x1="0" x2="1">
            <stop offset="0" stopColor="#1e3a8a" />
            <stop offset="1" stopColor="#3b82f6" />
          </linearGradient>
        </defs>
        <rect width="120" height="32" fill="url(#phHead)" />
        {/* H+ logo */}
        <rect x="10" y="10" width="12" height="12" fill="#ffffff" rx="1.5" />
        <path d="M16 12 v8 M12 16 h8" stroke="#1e3a8a" strokeWidth="1.6" />
        <text x="26" y="16" fontSize="6" fontFamily="sans-serif" fontWeight="700" fill="#ffffff">APOLLO+</text>
        <text x="26" y="22" fontSize="3.2" fontFamily="sans-serif" fill="#dbeafe">MULTI-SPECIALITY HOSPITAL</text>
        <text x="26" y="27" fontSize="2.6" fill="#bfdbfe">Reg. No.: PVT/HOS/9821</text>
        {/* Patient panel */}
        <rect x="10" y="38" width="100" height="14" fill="#eff6ff" rx="1.5" />
        <text x="14" y="44" fontSize="3.2" fill="#1e3a8a" fontWeight="700">PATIENT DETAILS</text>
        <line x1="14" y1="46" x2="106" y2="46" stroke="#bfdbfe" strokeWidth="0.3" />
        <line x1="14" y1="50" x2="106" y2="50" stroke="#bfdbfe" strokeWidth="0.3" />
        {/* Body */}
        {[60, 68, 76, 84, 92, 100, 108].map((y) => (
          <line key={y} x1="14" y1={y} x2="106" y2={y} stroke="#cbd5e1" strokeWidth="0.4" />
        ))}
        {/* QR-style code + signature */}
        <rect x="10" y="125" width="20" height="20" fill="#1e3a8a" />
        <rect x="13" y="128" width="4" height="4" fill="#ffffff" />
        <rect x="23" y="128" width="4" height="4" fill="#ffffff" />
        <rect x="13" y="138" width="4" height="4" fill="#ffffff" />
        <rect x="19" y="134" width="2" height="2" fill="#ffffff" />
        <path d="M60 138 Q 75 130, 90 138 T 110 138" stroke="#1e3a8a" strokeWidth="0.7" fill="none" />
      </svg>
    );
  }

  if (variant === 'clinic') {
    return (
      <svg viewBox="0 0 120 160" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <rect width="120" height="160" fill="#fffbeb" />
        {/* Top accent */}
        <rect width="120" height="3" fill="#f59e0b" />
        {/* Doctor info */}
        <text x="14" y="14" fontSize="6" fontFamily="serif" fontWeight="700" fill="#7c2d12">Dr. P. Bansal</text>
        <text x="14" y="20" fontSize="3" fill="#92400e">M.B.B.S., D.C.H</text>
        <text x="14" y="25" fontSize="2.8" fill="#92400e">Reg.: MMC/8821</text>
        {/* Clinic name (right side) */}
        <text x="106" y="14" textAnchor="end" fontSize="5" fontFamily="serif" fontWeight="700" fill="#7c2d12">SUNRISE</text>
        <text x="106" y="20" textAnchor="end" fontSize="3" fill="#92400e">FAMILY CLINIC</text>
        <text x="106" y="25" textAnchor="end" fontSize="2.6" fill="#92400e">Open 10am–8pm</text>
        <line x1="10" y1="30" x2="110" y2="30" stroke="#f59e0b" strokeWidth="0.5" />
        {/* Rx */}
        <text x="14" y="42" fontSize="11" fontFamily="serif" fontStyle="italic" fontWeight="700" fill="#7c2d12">℞</text>
        {/* Handwriting-style lines */}
        <path d="M28 44 Q 35 41, 50 44 T 90 44" stroke="#1f2937" strokeWidth="0.5" fill="none" />
        <path d="M14 56 Q 30 52, 55 56 T 100 56" stroke="#1f2937" strokeWidth="0.5" fill="none" />
        <path d="M14 66 Q 25 62, 50 66 T 95 66" stroke="#1f2937" strokeWidth="0.5" fill="none" />
        <path d="M14 76 Q 35 72, 60 76 T 105 76" stroke="#1f2937" strokeWidth="0.5" fill="none" />
        <path d="M14 86 Q 30 82, 55 86 T 90 86" stroke="#1f2937" strokeWidth="0.5" fill="none" />
        <path d="M14 96 Q 25 92, 45 96 T 80 96" stroke="#1f2937" strokeWidth="0.5" fill="none" />
        {/* Bottom signature */}
        <path d="M70 130 Q 80 122, 90 130 T 105 130" stroke="#7c2d12" strokeWidth="0.7" fill="none" />
        <line x1="65" y1="138" x2="110" y2="138" stroke="#92400e" strokeWidth="0.3" />
        <text x="87" y="146" textAnchor="middle" fontSize="3" fill="#92400e">{"Dr's Signature"}</text>
      </svg>
    );
  }

  return null;
};

export default TemplatePreview;
